export default __webpack_public_path__ + "static/media/year.aef441de.svg";